module.exports = __webpack_public_path__ + "img/tags.658fa994.png";